<template>
  <a-modal
    :bodyStyle="{ padding: '8px 24px 24px 24px' }"
    :footer="null"
    :width="650"
    :visible="visible"
    @cancel="handleClose"
    :destroy-on-close="true"
  >
    <a-tabs>
      <a-tab-pane key="monitor" tab="监控客户端">
        <a-alert
          message="版本要求"
          style="border-radius: 8px; margin-bottom: 8px"
          type="info"
          banner
        >
          <template slot="description">
            <div>
              <b>Linux：</b>目前仅支持Linux 内核版本 2.12 及以上的 64 位版本。
            </div>
            <div>
              <b>Windows (PowerShell 3.0+):</b>目前仅支持Windows Server 2008 r2 及以上的 64 位版本。
            </div>
          </template>
        </a-alert>

        <div class="module-header-fs14" style="margin: 24px 0 8px 0">Linux</div>
        <div style="padding: 0 8px">
          <div style="display: inline-block; font-weight: bold; margin: 4px 0">ARM：</div>
          <div style="padding: 0 16px">
            <div>麒麟：</div>
            <div style="padding: 0 16px">
              <div>
                <span>/opt 目录：</span>
                <a @click="click('opseye-monitor-agent-ql-arm64-opt.tar.gz')">opseye-monitor-agent-ql-arm64-opt.tar.gz</a>
              </div>
              <div>
                <span>/data 目录：</span>
                <a @click="click('opseye-monitor-agent-ql-arm64-data.tar.gz')">opseye-monitor-agent-ql-arm64-data.tar.gz</a>
              </div>
            </div>
            <div>统信：</div>
            <div style="padding: 0 16px">
              <div>
                <span>/opt 目录：</span>
                <a @click="click('opseye-monitor-agent-tx-arm64-opt.tar.gz')">opseye-monitor-agent-tx-arm64-opt.tar.gz</a>
              </div>
              <div>
                <span>/data 目录：</span>
                <a @click="click('opseye-monitor-agent-tx-arm64-data.tar.gz')">opseye-monitor-agent-tx-arm64-data.tar.gz</a>
              </div>
            </div>
          </div>
          <div style="display: inline-block; font-weight: bold; margin: 4px 0">x86-64：</div>
          <div style="padding: 0 16px">
            <div>麒麟：</div>
            <div style="padding: 0 16px">
              <div>
                <span>/opt 目录：</span>
                <a @click="click('opseye-monitor-agent-ql-x86_64-opt.tar.gz')">opseye-monitor-agent-ql-x86_64-opt.tar.gz</a>
              </div>
              <div>
                <span>/data 目录：</span>
                <a @click="click('opseye-monitor-agent-ql-x86_64-data.tar.gz')">opseye-monitor-agent-ql-x86_64-data.tar.gz</a>
              </div>
            </div>
            <div>CentOS/Ubuntu/统信/欧拉：</div>
            <div style="padding: 0 16px">
              <div>
                <span>/opt 目录：</span>
                <a @click="click('opseye-monitor-agent-x86_64-opt.tar.gz')">opseye-monitor-agent-x86_64-opt.tar.gz</a>
              </div>
              <div>
                <span>/data 目录：</span>
                <a @click="click('opseye-monitor-agent-x86_64-data.tar.gz')">opseye-monitor-agent-x86_64-data.tar.gz</a>
              </div>
            </div>
          </div>
        </div>
        <div class="module-header-fs14" style="margin: 24px 0 8px 0">Windows</div>
        <div style="padding: 0 8px">
          <div style="display: inline-block; font-weight: bold; margin: 4px 0">x86-64：</div>
          <div style="padding: 0 16px">
            <span>C:\ 目录：</span>
            <a @click="click('opseye-monitor-agent-win-x86_64.zip')">opseye-monitor-agent-win-x86_64.zip</a>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="log" tab="日志客户端">
        <div class="module-header-fs14">Linux</div>
        <div style="padding: 0 8px">
          <div style="display: inline-block; font-weight: bold; margin: 4px 0">ARM：</div>
          <div style="padding: 0 16px">
            <div>
              <span>/opt 目录：</span>
              <a @click="click('filebeat-8.10.4-linux-arm64-opt.tar.gz')">filebeat-8.10.4-linux-arm64-opt.tar.gz</a>
            </div>
            <div>
              <span>/data 目录：</span>
              <a @click="click('filebeat-8.10.4-linux-arm64-data.tar.gz')">filebeat-8.10.4-linux-arm64-data.tar.gz</a>
            </div>
          </div>
          <div style="display: inline-block; font-weight: bold; margin: 4px 0">x86-64：</div>
          <div style="padding: 0 16px">
            <div>
              <span>/opt 目录：</span>
              <a @click="click('filebeat-8.10.4-linux-x86_64-opt.tar.gz')">filebeat-8.10.4-linux-x86_64-opt.tar.gz</a>
            </div>
            <div>
              <span>/data 目录：</span>
              <a @click="click('filebeat-8.10.4-linux-x86_64-data.tar.gz')">filebeat-8.10.4-linux-x86_64-data.tar.gz</a>
            </div>
          </div>
        </div>
        <div class="module-header-fs14" style="margin: 24px 0 8px 0">Windows</div>
        <div style="padding: 0 8px">
          <div style="display: inline-block; font-weight: bold; margin: 4px 0">x86-64：</div>
          <div style="padding: 0 16px">
            <span>C:\ 目录：</span>
            <a @click="click('winlogbeat-8.10.4-windows-x86_64.zip')">winlogbeat-8.10.4-windows-x86_64.zip</a>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import { download } from '@/api/download'

export default {
  name: 'InstallModal',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    handleClose () {
      this.visible = false
    },
    click (filename) {
      download({ filename }).then(res => {
        const blob = new Blob([res], { type: res.type })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    copy (type) {
      const ele = type === 'linux' ? document.querySelector('#linux-code') : document.querySelector('#windows-code')
      const str = ele.innerText
      if (!navigator.clipboard) {
        var textArea = document.createElement('textarea')
        textArea.value = str
        textArea.style.position = 'fixed'
        document.body.appendChild(textArea)
        textArea.select()
        try {
          document.execCommand('copy')
          this.$message.success('已复制到剪贴板！')
        } catch (err) {
          this.$message.error('复制到剪贴板失败！请手动复制。')
        }
        document.body.removeChild(textArea)
      } else {
        navigator.clipboard.writeText(str)
          .then(() => {
            this.$message.success('已复制到剪贴板！')
          })
          .catch(() => {
            this.$message.error('复制到剪贴板失败！！请手动复制。')
          })
      }
    }
  }
}
</script>
